module.exports = __webpack_public_path__ + "static/urbanhus-line-drawing-22a25ce5457156d3de22e0a6a756dab3.gif";